!(function (e, a) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = a())
    : 'function' == typeof define && define.amd
      ? define(a)
      : ((e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}), (e.ReactIntlLocaleData.eu = a()));
})(this, function () {
  'use strict';
  return [
    {
      locale: 'eu',
      pluralRuleFunction: function (e, a) {
        return a ? 'other' : 1 == e ? 'one' : 'other';
      },
      fields: {
        year: {
          displayName: 'urtea',
          relative: { 0: 'aurten', 1: 'hurrengo urtean', '-1': 'iaz' },
          relativeTime: {
            future: { one: '{0} urte barru', other: '{0} urte barru' },
            past: { one: 'Duela {0} urte', other: 'Duela {0} urte' }
          }
        },
        'year-short': {
          displayName: 'urtea',
          relative: { 0: 'aurten', 1: 'hurrengo urtea', '-1': 'aurreko urtea' },
          relativeTime: {
            future: { one: '{0} urte barru', other: '{0} urte barru' },
            past: { one: 'Duela {0} urte', other: 'Duela {0} urte' }
          }
        },
        month: {
          displayName: 'hilabetea',
          relative: { 0: 'hilabete honetan', 1: 'hurrengo hilabetean', '-1': 'aurreko hilabetean' },
          relativeTime: {
            future: { one: '{0} hilabete barru', other: '{0} hilabete barru' },
            past: { one: 'Duela {0} hilabete', other: 'Duela {0} hilabete' }
          }
        },
        'month-short': {
          displayName: 'hil.',
          relative: { 0: 'hilabete honetan', 1: 'hurrengo hilabetean', '-1': 'aurreko hilabetean' },
          relativeTime: {
            future: { one: '{0} hilabete barru', other: '{0} hilabete barru' },
            past: { one: 'Duela {0} hilabete', other: 'Duela {0} hilabete' }
          }
        },
        day: {
          displayName: 'eguna',
          relative: { 0: 'gaur', 1: 'bihar', 2: 'etzi', '-2': 'herenegun', '-1': 'atzo' },
          relativeTime: {
            future: { one: '{0} egun barru', other: '{0} egun barru' },
            past: { one: 'Duela {0} egun', other: 'Duela {0} egun' }
          }
        },
        'day-short': {
          displayName: 'eg.',
          relative: { 0: 'gaur', 1: 'bihar', 2: 'etzi', '-2': 'herenegun', '-1': 'atzo' },
          relativeTime: {
            future: { one: '{0} egun barru', other: '{0} egun barru' },
            past: { one: 'Duela {0} egun', other: 'Duela {0} egun' }
          }
        },
        hour: {
          displayName: 'ordua',
          relative: { 0: 'ordu honetan' },
          relativeTime: {
            future: { one: '{0} ordu barru', other: '{0} ordu barru' },
            past: { one: 'Duela {0} ordu', other: 'Duela {0} ordu' }
          }
        },
        'hour-short': {
          displayName: 'h',
          relative: { 0: 'ordu honetan' },
          relativeTime: {
            future: { one: '{0} ordu barru', other: '{0} ordu barru' },
            past: { one: 'Duela {0} ordu', other: 'Duela {0} ordu' }
          }
        },
        minute: {
          displayName: 'minutua',
          relative: { 0: 'minutu honetan' },
          relativeTime: {
            future: { one: '{0} minutu barru', other: '{0} minutu barru' },
            past: { one: 'Duela {0} minutu', other: 'Duela {0} minutu' }
          }
        },
        'minute-short': {
          displayName: 'min',
          relative: { 0: 'minutu honetan' },
          relativeTime: {
            future: { one: '{0} minutu barru', other: '{0} minutu barru' },
            past: { one: 'Duela {0} minutu', other: 'Duela {0} minutu' }
          }
        },
        second: {
          displayName: 'segundoa',
          relative: { 0: 'orain' },
          relativeTime: {
            future: { one: '{0} segundo barru', other: '{0} segundo barru' },
            past: { one: 'Duela {0} segundo', other: 'Duela {0} segundo' }
          }
        },
        'second-short': {
          displayName: 's',
          relative: { 0: 'orain' },
          relativeTime: {
            future: { one: '{0} segundo barru', other: '{0} segundo barru' },
            past: { one: 'Duela {0} segundo', other: 'Duela {0} segundo' }
          }
        }
      }
    }
  ];
});
